"use client";

import { Suspense, useState } from "react";
import { useGetProfileJobsSuspense } from "@/lib/api/generated";
import { SectionBody, SectionCard } from "../../section-layout";
import { useProfile } from "../../context";
import { JobRow } from "./job-row";
import { JobsPending } from "./pending";
import { JobsEmpty } from "./empty";
import { JobsPagination } from "./pagination";

const PER_PAGE = 10;

function JobsList({ profileId }: { profileId: string }) {
  const [page, setPage] = useState(1);
  const { profile } = useProfile();
  const candidateName = profile?.full_name ?? undefined;
  const { data, isPending } = useGetProfileJobsSuspense(profileId, {
    page,
    per_page: PER_PAGE,
  });
  const { jobs, total } = data;
  const totalPages = Math.max(1, Math.ceil(total / PER_PAGE));

  if (total === 0) return <JobsEmpty />;

  const handlePageChange = (next: number) => {
    setPage(next)
  };

  return (
    <SectionBody
      className={`gap-2 transition-opacity ${isPending ? "opacity-60" : ""}`}
    >
      {jobs.map((item) => (
        <JobRow
          key={item.job_candidate_id}
          item={item}
          candidateName={candidateName}
        />
      ))}
      {totalPages > 1 && (
        <JobsPagination
          page={page}
          totalPages={totalPages}
          total={total}
          onPageChange={handlePageChange}
        />
      )}
    </SectionBody>
  );
}

export function JobsSection({ profileId }: { profileId: string }) {
  return (
    <SectionCard title="Jobs">
      <Suspense fallback={<JobsPending />}>
        <JobsList profileId={profileId} />
      </Suspense>
    </SectionCard>
  );
}
